import { format, formatDistanceStrict } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import { ActingDetailQueryResponse } from '@area-restrita/api-client/model/actingDetailQueryResponse';

type ActingStatus = ActingDetailQueryResponse['status'];
type ActingStep = ActingDetailQueryResponse['steps'][number];

const statusLabels: Record<ActingStatus, string> = {
  started: 'Em andamento',
  finished: 'Finalizada',
  aborted: 'Abortada',
  abandoned: 'Abandonada',
};

export const getActingStatusLabel = (status: ActingStatus) =>
  statusLabels[status];

export const formatActingDateTime = (value: string | null | undefined) =>
  value ? format(new Date(value), 'dd/MM/yyyy HH:mm') : 'Não registrado';

export const formatActingDuration = (
  startedAt: string,
  finishedAt: string | null,
  now = new Date(),
) =>
  formatDistanceStrict(
    new Date(startedAt),
    finishedAt ? new Date(finishedAt) : now,
    {
      locale: ptBR,
    },
  );

export const getCompletedStepsCount = (steps: ActingStep[]) =>
  steps.filter((step) => Boolean(step.finishedAt)).length;

export const getStepStatus = (step: ActingStep) => {
  if (step.finishedAt) return 'Concluída';
  if (step.startedAt) return 'Em andamento';
  return 'Não iniciada';
};

export const isCheckedResponse = (value: string | null) => value === '1';

export const getActingRefreshInterval = (
  status: ActingStatus | undefined,
): 15000 | false => (status === 'started' ? 15000 : false);

export const formatRouteDistance = (meters: number | null | undefined) => {
  if (meters == null) return 'Indisponível';
  if (meters < 1000) return `${Math.round(meters)} m`;

  return `${(meters / 1000).toLocaleString('pt-BR', {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
  })} km`;
};

export const formatRoutePercentage = (percentage: number | null | undefined) =>
  percentage == null
    ? 'Indisponível'
    : `${percentage.toLocaleString('pt-BR', {
        maximumFractionDigits: 1,
      })}%`;

export const formatRouteCount = (count: number | null | undefined) =>
  count == null ? 'Indisponível' : count.toLocaleString('pt-BR');
